import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_2 = {
  key: 2,
  class: "text-sm text-gray-600"
}
const _hoisted_3 = { class: "flex flex-wrap items-end gap-3" }
const _hoisted_4 = { class: "-my-3.5" }
const _hoisted_5 = { class: "text-sm text-gray-700" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-gray-500"
}

import { computed } from 'vue'

import InputArea from '@/components/neue/InputArea.vue'
import InputField from '@/components/neue/InputField.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import AmountField from '@/components/neue/wizard/AmountField.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { customersOf, newPackage, sectionCopy } from '@/config/membershipTierWizardSteps'
import { packagesCopy } from '@/helpers/membershipTierWizardSummary'


export default {
  __name: 'StepPackages',
  props: {
  packages: { type: Array, default: () => [] },
  stores: { type: Array, default: () => [] }
},
  setup(__props) {

const props = __props

const wizard = injectWizard()
const severalStores = computed(() => new Set(props.packages.map(p => p.storeName)).size > 1)
const limitedPackages = computed(() => props.packages.filter(p => !p.openToAll))
const packageText = computed(() => packagesCopy(wizard.data, props.packages))
const storeOptions = computed(() => props.stores.map(store => ({ name: store.name, value: store.id })))
const openToAllHelp = computed(
  () =>
    `Off: only ${customersOf(wizard.data)} can pick the package. On: customers on every membership can pick the package.`
)

const packageSubtitle = option =>
  [severalStores.value ? option.storeName : null, option.isOn ? null : 'Turned off'].filter(Boolean).join(' · ')

const togglePackage = id => {
  const ids = wizard.data.packageIds
  wizard.data.packageIds = ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
}

const startingStore = () => {
  if (props.stores.length === 1) return props.stores[0].id
  const { mode, storeIds } = wizard.data.joining
  return mode === 'checkout' && storeIds.length === 1 ? storeIds[0] : null
}

const addPackage = () => {
  wizard.data.newPackages = [...wizard.data.newPackages, newPackage(startingStore())]
}

const removePackage = index => {
  wizard.data.newPackages = wizard.data.newPackages.filter((_, i) => i !== index)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.packages.length)
      ? (_openBlock(), _createBlock(WizardSection, _mergeProps({ key: 0 }, _unref(sectionCopy)('packages', _unref(wizard).data), { plain: "" }), {
          default: _withCtx(() => [
            (packageText.value.limitedIntro)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                  _createVNode(_unref(HighlightedText), {
                    text: packageText.value.limitedIntro
                  }, null, 8, ["text"])
                ]))
              : _createCommentVNode("", true),
            (limitedPackages.value.length)
              ? (_openBlock(), _createBlock(SelectionGroup, {
                  key: 1,
                  label: _unref(sectionCopy)('packages', _unref(wizard).data).title,
                  mode: "check"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedPackages.value, (option) => {
                      return (_openBlock(), _createBlock(SelectionCard, {
                        key: option.id,
                        mode: "check",
                        compact: "",
                        title: option.name,
                        subtitle: packageSubtitle(option),
                        selected: _unref(wizard).data.packageIds.includes(option.id),
                        onSelect: $event => (togglePackage(option.id))
                      }, null, 8, ["title", "subtitle", "selected", "onSelect"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (packageText.value.openNote)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createVNode(_unref(HighlightedText), {
                    text: packageText.value.openNote
                  }, null, 8, ["text"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true),
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('newPackages', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wizard).data.newPackages, (pkg, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            "data-new-package": "",
            class: "space-y-4 rounded-xl border border-gray-200 bg-white p-5"
          }, [
            _createVNode(InputField, {
              modelValue: pkg.name,
              "onUpdate:modelValue": $event => ((pkg.name) = $event),
              name: "Package name"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(InputArea, {
              modelValue: pkg.description,
              "onUpdate:modelValue": $event => ((pkg.description) = $event),
              name: "Package description",
              rows: "2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            (__props.stores.length > 1)
              ? (_openBlock(), _createBlock(SelectInput, {
                  key: 0,
                  "model-value": pkg.storeId,
                  name: "Store",
                  placeholder: "Pick a store",
                  options: storeOptions.value,
                  "onUpdate:modelValue": $event => (pkg.storeId = $event)
                }, null, 8, ["model-value", "options", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(NumberStepper, {
                modelValue: pkg.minimumItems,
                "onUpdate:modelValue": $event => ((pkg.minimumItems) = $event),
                name: "Minimum number of items"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(AmountField, {
                modelValue: pkg.minimumPriceCents,
                "onUpdate:modelValue": $event => ((pkg.minimumPriceCents) = $event),
                kind: "money",
                name: "Minimum order value"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(ToggleRow, {
                modelValue: pkg.openToAll,
                "onUpdate:modelValue": $event => ((pkg.openToAll) = $event),
                title: "Offer to every membership",
                description: openToAllHelp.value
              }, null, 8, ["modelValue", "onUpdate:modelValue", "description"])
            ]),
            _createVNode(WizardButton, {
              onClick: $event => (removePackage(index))
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Remove", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]))
        }), 128)),
        _createElementVNode("div", null, [
          _createVNode(WizardButton, { onClick: addPackage }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Create a package", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('packagesSeen', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_5, [
          _createVNode(_unref(HighlightedText), {
            text: packageText.value.seen
          }, null, 8, ["text"])
        ]),
        (packageText.value.hiddenNote)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createVNode(_unref(HighlightedText), {
                text: packageText.value.hiddenNote
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}